export const DISCOUNT_COOKIE_KEY = "discount_code";
